import React, { lazy, Suspense, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { resolveClientAdminSession } from '../core/auth/resolveClientAdminSession';
import { useTokenManager } from '../contexts/TokenManagerContext';

const ArtistRouter = lazy(() => import('./ArtistRouter'));

const LoadingSpinner = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#02172a',
      color: '#fff',
    }}
  >
    <div>Loading...</div>
  </div>
);

/**
 * `/analytics` is overloaded: admins use `AdminAnalytics` under `/admin/analytics`,
 * artists/streamers use `pages/Analytics` inside `ArtistRouter`. App root must not
 * send everyone through `AdminRouter` (that triggers Access Denied for non-admins).
 */
const RoleAnalyticsRouter: React.FC = () => {
  const { getToken } = useTokenManager();
  const routingToken = getToken?.() ?? null;
  const isAdmin = useMemo(
    () => resolveClientAdminSession(routingToken),
    [routingToken]
  );

  if (isAdmin) {
    return <Redirect to="/admin/analytics" />;
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ArtistRouter />
    </Suspense>
  );
};

export default RoleAnalyticsRouter;
